module.exports = __webpack_public_path__ + "static/img/day7.e384c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/day7.jpg
// module id = uvNG
// module chunks = 0